import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import SearchBox from "../search-box";
import NewsCard from "../events/events-card";
import ReactPaginate from "react-paginate";
import Api from '../../../lib/seam-api';
import CustomSelect from '../select';
import NoResults from '../no-results';
import {fireEnquireOpenEvent} from "../../overlay/enquire";
import MeetingCard from '../../../components/meeting-card';
import InputsDate from '../../../components/inputs/inputs-date';
import seamApi from '../../../lib/seam-api';
import { max } from 'lodash';
import dayjs from 'dayjs';
import MediaHelper from '../../../lib/helpers/media';
import InputsDropdown from '../../../components/inputs/inputs-dropdown';
import humanizeDuration from 'humanize-duration';
import MediaQuery from 'react-responsive';
import { FormatMonths } from '../../../lib/helpers';
import ArrowRight from '../../../icons/arrow-right';

import RenderThisIf from '../../../components/renderIf';

const el = document.getElementById('memberships-component');

import utc from 'dayjs/plugin/utc';
import tableCarousel from '../../table-carousel';

dayjs.extend(utc);

class MembershipsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items : [],
            page: 1,
        };
    }

    componentDidMount() {
        this.fetchItems(); 
    }

    fetchItems(page = this.state.page) {
        seamApi.memberships().getMemberships({
            per_page: 1000,
            page: 1,
        }).then(({ data }) => {
            this.setState({
                items: data
            }, () => {
                tableCarousel();
            })
        })
    }

    render() {
        return (
            <>
                <div className="table__prices">
                    { this.state.items?.map((membership, index) => {
                        const getFeaturedImage = () => {
                            const image = membership?.content?.feature_image?.[0];
                    
                            if (image?.file_name === undefined) return '/images/office.png';
                    
                            return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
                        }

                        return (
                            <div class={`table__price ${!this.props.switch ? 'table__price--min' : ''}`}>
                                <div class="table-price__top">
                                    { membership?.has_offer ? <a class="table-price__offer" href={`/memberships/${membership.id}`}>
                                        <div class="table-offer__text">Try free Day</div>
                                        <div class="table-offer__information">i</div>
                                    </a> : '' }
                                    <div class="table-price__image">
                                        <div class="table-price__overlay"></div>
                                        <img class="lazyload" data-src={getFeaturedImage()} alt={`${membership?.name} Image`}/>
                                    </div>
                                    <div class="table-price__price">
                                        { membership?.name }
                                    </div>
                                </div>
                                <div class="table-price__information">
                                    <div class="table-price__inner">
                                        { new Array(3).fill(0)?.map((_, index) => {
                                            return (
                                                <div class="table-price__item table-price__item-info">
                                                    { membership?.content?.features?.[index] ? membership?.content?.features?.[index]?.name : '' }
                                                </div>
                                            )
                                        }) }
                                    </div>

                                    <div>
                                        <div class="table-price__item table-price__item-more"><a href={`/memberships/${membership.id}`}>+ more...</a></div>
                                        <a href={`/memberships/${membership.id}`} class="table-price__item table-price__item-price" style={{ textDecoration: 'none' }}>£{ membership?.monthly_price } every month - Enquire today <img src="/images/assets/arrows/text-arrow.svg" alt="Right Arrow"/></a>
                                    </div>
                                </div>
                            </div>
                        )
                    }) }
                </div>

                <div class="pagination__bottom pagination__circle-color--orange pagination__arrow-color--white">
                    <div class="pagination-arrow prev" dangerouslySetInnerHTML={{ __html: '<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.5 9.24"><g id="Menu_Underline" transform="translate(0 0.666)"><line id="Line_4" y1="4.62" x2="37" y2="4.62" style="fill:none; stroke:#000;"/><path id="Path_1" d="M28.48,.5l8.52,4.04-8.52,4.2" style="fill:none; stroke:#000; stroke-linecap:round; stroke-linejoin:round;"/></g></svg>' }}></div>
                    <div class="pagination-arrow next" dangerouslySetInnerHTML={{ __html: '<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.5 9.24"><g id="Menu_Underline" transform="translate(0 0.666)"><line id="Line_4" y1="4.62" x2="37" y2="4.62" style="fill:none; stroke:#000;"/><path id="Path_1" d="M28.48,.5l8.52,4.04-8.52,4.2" style="fill:none; stroke:#000; stroke-linecap:round; stroke-linejoin:round;"/></g></svg>' }}></div>
                </div>
            </>
        )
    }
}

if(el)  {
    const switchProp = el.getAttribute('data-switch');

   ReactDOM.render(<MembershipsComponent switch={switchProp}/>, el);
}
